import Pessoa from "model/administracao/cadastro/Pessoa";
import Produto from "model/administracao/cadastro/produto/Produto";
import { BaseModel } from "model/BaseModel";
import MetaProducaoOperacao from "./MetaProducaoOperacao";
import MetaProducaoHorario from "./MetaProducaoHorario";
import HorarioDia from "./HorarioDia";

export default class MetaProducao implements BaseModel {
    id: number;
    codigo: string | null = "";
    quantidade: number;
    data: Date | null;
    quantidadeHoras: number;
    produto: Produto | null;
    cliente: Pessoa | null;
    horarioDia: HorarioDia | null;
    horarios: MetaProducaoHorario[];
    operacoes: MetaProducaoOperacao[];

    constructor(
        id = 0,
        quantidade = 0,
        data = new Date(),
        quantidadeHoras = 0,
        produto = null,
        cliente = null,
        horarioDia = null,
        horarios = [],
        operacoes = []
    ) {
        this.id = id;
        this.quantidade = quantidade;
        this.data = data;
        this.quantidadeHoras = quantidadeHoras;
        this.produto = produto;
        this.cliente = cliente;
        this.horarioDia = horarioDia;
        this.horarios = horarios;
        this.operacoes = operacoes;
    }
}